import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NextPageService } from '@cvx/nextpage';
import { NextPageRoute } from "@cvx/nextpage";
import { HomeComponent } from "./components/home/home.component";
import { LibEditorComponent } from "./components/libEditor/libEditor.component";
import { UserAccessComponent } from "./components/userAccess/userAccess.component";
import { AccessDashboardComponent } from "./components/access-dashboard/access-dashboard.component";
import { MsalGuard } from "@azure/msal-angular";
import { RoleGuard } from "./guards/role.guard";

export const routes: NextPageRoute[] = [
  {
    path: 'lib-editor/:libraryName',
    title: 'Library Editor',
    component: LibEditorComponent,
    pathMatch: 'prefix',
    canActivate: [
        MsalGuard,
        RoleGuard
    ],
    data: {
      roles: [ 'Library.Admin', 'Library.Consumer' ]
    }
  },
  {
    // Handles navigating to the base '/lib-editor' path (no library selected yet).
    // No 'title' here so it doesn't create a duplicate nav-bar entry.
    path: 'lib-editor',
    component: LibEditorComponent,
    pathMatch: 'full',
    canActivate: [
        MsalGuard,
        RoleGuard
    ],
    data: {
      roles: [ 'Library.Admin', 'Library.Consumer' ]
    }
  },
  // {
  //   path: 'user-access',
  //   title: 'User Access',
  //   component: UserAccessComponent,
  //   pathMatch: 'prefix',
  //   canActivate: [
  //       MsalGuard,
  //       RoleGuard
  //   ],
  //   data: {
  //     roles: [ 'Library.Admin', 'Library.Consumer' ]
  //   }
  // },
  // {
  //   path: 'access-dashboard',
  //   title: 'Group Information',
  //   component: AccessDashboardComponent,
  //   pathMatch: 'prefix',
  //   canActivate: [
  //     MsalGuard,
  //     RoleGuard
  //   ],
  //   data: {
  //     roles: [ 'Library.Admin' ]
  //   }
  // },
  { path: '', component: HomeComponent, pathMatch: 'full'},
  { path: 'sign-in', component: HomeComponent, pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(private NP: NextPageService) {
    this.NP.options.navigationRoutes = routes;
  }
}
